import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import ChartGenerator from './pages/ChartGenerator'
import ChartDetail from './pages/ChartDetail'
import UserCenter from './pages/UserCenter'
import AuthCallback from './pages/AuthCallback'

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chart" element={<ChartGenerator />} />
        <Route path="/chart/:id" element={<ChartDetail />} />
        <Route path="/user" element={<UserCenter />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
      </Routes>
    </Layout>
  )
}

export default App
